export default "__VITE_ASSET__7edd237f__"